import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './fonts.css';
import './index.css';
import './globals.css';
import App from './App';

// Initialize Sentry only in production to avoid flooding error logs during development
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://37363cafb22bf38b80c2cc9366e054fe@o4510364396158976.ingest.de.sentry.io/4510364399108176",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

